import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import FormEvalCapaServices from "./FormEvalCapa.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFormEvalCapa = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_FORMEVALCAPA,
      payload: true,
    });
    const resp = await FormEvalCapaServices.getFormEvalCapa(filters);

    dispatch({
      type: actions.GET_FORMEVALCAPA,
      payload: resp.data,
    });

    dispatch({
      type: actions.FORMEVALCAPA_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FORMEVALCAPA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_FORMEVALCAPA,
      payload: false,
    });
  }
};

export const saveFormEvalCapa = (req) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_FORMEVALCAPA,
      payload: true,
    });
    const resp = await FormEvalCapaServices.saveFormEvalCapa(req);

    dispatch({
      type: actions.GET_FORMEVALCAPA,
      payload: resp.data,
    });
    dispatch({
      type: actions.FORM_FORMEVALCAPA_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FORMEVALCAPA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_FORMEVALCAPA,
      payload: false,
    });
  }
};

export const editFormEvalCapa =
  (req, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_FORMEVALCAPA,
        payload: true,
      });
      const resp = await FormEvalCapaServices.editFormEvalCapa(req.id, req);
      const { data, count } = getState().formEvalCapa.formEvalCapa;
      const { data: dataAnio } = getState().formEvalCapa.formEvalCapaAnio;
      let _data = data.slice();
      _data[index] = resp.data;
      dispatch({
        type: actions.GET_FORMEVALCAPA,
        payload: {
          formEvalCapa: { data: _data, count: count },
          formEvalCapaAnio: { data: dataAnio },
        },
      });
      // dispatch({
      //     type: actions.GET_FORMEVALCAPA,
      //     payload: {
      //         data: _data,
      //         count: count,
      //     },
      // });
      dispatch({
        type: actions.FORM_FORMEVALCAPA_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_FORMEVALCAPA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_FORMEVALCAPA,
        payload: false,
      });
    }
  };

export const deleteFormEvalCapa =
  (id, index, reOrder, list) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_FORMEVALCAPA,
        payload: true,
      });
      await FormEvalCapaServices.deleteFormEvalCapa(id);
      const { data, count } = getState().formEvalCapa.formEvalCapa;
      const { data: dataAnio } = getState().formEvalCapa.formEvalCapaAnio;
      let _data = data.slice();
      let _list = list.slice();
      _list.splice(index, 1);
      _data.splice(index, 1);
      dispatch({
        type: actions.GET_FORMEVALCAPA,
        payload: {
          formEvalCapa: { data: _list, count: count - 1 },
          formEvalCapaAnio: { data: dataAnio },
        },
      });
      // dispatch({
      //     type: actions.GET_FORMEVALCAPA,
      //     payload: {
      //         data: _list,
      //         count: count - 1
      //     },
      // });
      reOrder(_list);
      dispatch({
        type: actions.FORMEVALCAPA_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORMEVALCAPA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_FORMEVALCAPA,
        payload: false,
      });
    }
  };
